export const focusDirective = {
  mounted(el: HTMLInputElement) {
    el.focus();
  },
};
